import axios from 'axios'

const axiosInstance = function () {
  return axios.create({
    baseURL: `http://api.openweathermap.org`,
    timeout: 50000
    // withCredentials: true,
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Accept': 'application/json'
    // }
  })
}
export function getWeatherAPI (payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance().get(`https://api.openweathermap.org/data/2.5/weather?lat=${payload.lat}&lon=${payload.lon}&appid=1e5e3d5c9c01d394508a72c8fa1ed9de`)
      .then(response => resolve(response))
      .catch(err => reject(err))
  })
}
export function getAdressAPI (payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance().get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${payload.lat},${payload.lon}&language=en&key=AIzaSyCNo2mP00QzuUpd8_EhdM93zhkk6CbbawI`)
      .then(response => resolve(response))
      .catch(err => reject(err))
  })
}
